var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4262.85 3658.89h-59.16v176.41h59.16v-176.41",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4270.16 3653.77h-74.69v65.18h74.69v-65.18",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4454.92 3658.89h-59.16v176.41h59.16v-176.41",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4462.23 3653.77h-74.69v65.18h74.69v-65.18",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4469.92 3871.15h-278.9v102.25h278.9v-102.25",
    style: {
      fill: "#e14f21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4170.88 3668.43c4.71 11.8 98.96 17.68 119.49 3.43 6.54-4.48 10.29-34.32 10.29-34.32h-135.72s2.25 21.54 5.94 30.89",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4164.94 3621.79h135.72v15.75h-135.72v-15.75",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4490.1 3668.43c-4.71 11.8-98.97 17.68-119.51 3.43-6.55-4.48-10.3-34.32-10.3-34.32h135.73s-2.23 21.54-5.92 30.89",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4496.02 3621.79h-135.73v15.75h135.73v-15.75",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4310.31 4423.29v-62.62h42.87v62.62h-42.87",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4450.18 4518.7c0-67.91-58.87-126.72-138.15-126.72-79.35 0-143.59 55-143.59 122.91 0 177.71 61.52 181.9 140.84 181.9 79.31 0 140.9-18.38 140.9-178.09",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4195.63 4486.31c0-10.86-8.81-19.67-19.65-19.67-10.84 0-19.69 8.81-19.69 19.67 0 10.84 8.85 19.67 19.69 19.67 10.84 0 19.65-8.83 19.65-19.67m232.77 0c0-10.86 8.83-19.67 19.69-19.67 10.86 0 19.66 8.81 19.66 19.67 0 10.84-8.8 19.67-19.66 19.67s-19.69-8.83-19.69-19.67",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4280.1 4536.76c0-8.05-6.53-14.63-14.57-14.63-8.03 0-14.53 6.58-14.53 14.63 0 7.96 6.5 14.53 14.53 14.53 8.04 0 14.57-6.57 14.57-14.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4273.18 4540.19c0-3.32-2.71-6.05-6.05-6.05s-6.02 2.73-6.02 6.05c0 3.33 2.68 6.01 6.02 6.01 3.34 0 6.05-2.68 6.05-6.01",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4340.98 4536.76c0-8.05 6.56-14.63 14.59-14.63 7.98 0 14.55 6.58 14.55 14.63 0 7.96-6.57 14.53-14.55 14.53-8.03 0-14.59-6.57-14.59-14.53",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4347.91 4540.19c0-3.32 2.72-6.05 6.05-6.05 3.34 0 6.04 2.73 6.04 6.05 0 3.33-2.7 6.01-6.04 6.01-3.33 0-6.05-2.68-6.05-6.01",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4259.84 4576.27c-13.69 0-25.43-4.7-31.36-11.62 0 0 14.72 8.09 31.36 8.09 17.43 0 31.29-8.09 31.29-8.09-5.88 6.92-17.6 11.62-31.29 11.62m98.89 0c13.69 0 25.43-4.7 31.35-11.62 0 0-14.71 8.09-31.35 8.09-17.44 0-31.31-8.09-31.31-8.09 5.9 6.92 17.66 11.62 31.31 11.62",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4370.16 4647.59c-31.66-12.74-91.39-24.8-142.76 18.54-62.62 52.85-3.32 154.28 47.62 151.64 0 0-23.85-51.13 4.92-60.36 28.85-9.28 135.98 30.37 125.14-82-.67-7.16-3.71-15.32-34.92-27.82",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4186.54 4685.88s-70.94-81.62-11.64-199.59c0 0 2.4 58.08 14.3 100.02 18.12 63.83 48.22 86.68 33.5 117.37-14.71 30.68-36.16-17.8-36.16-17.8m242.66 0s70.98-81.62 11.68-199.59c0 0-2.48 58.08-14.38 100.02-18.08 63.83-48.22 86.68-33.47 117.37 14.76 30.68 36.17-17.8 36.17-17.8",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4395.96 4660.92s-150.51-101.18-272.56 41.77c0 0 60.58-30.05 156.7 3.66 96.11 33.76 115.86-45.43 115.86-45.43",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4164.08 4670.46s-24.55-69.15-44.18-70.41c0 0 34.06-11.07 48.54 12.63 14.45 23.77 15.25 81.17-4.36 57.78",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4154.26 4608.61s-4.77-63.61-41.53-68.42c0 0 39.59-34.21 55.71 19.95 16.07 54.21-14.18 48.47-14.18 48.47m255.13 103.77s34.77-1.51 38.71 19.76c0 0 3.36-42.03-19.7-56.2-23.01-14.13-19.01 36.44-19.01 36.44",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4426.82 4690.8s15.37-29.69 48.92-20.34c0 0-18.98-39.14-47.34-28.9-28.32 10.26-1.58 49.24-1.58 49.24",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4448.28 4654.4s19.26-42.45 31.54-54.35c0 0-25.99 4.87-34.27 27.21-8.27 22.28 2.73 27.14 2.73 27.14m12.87-56.93s12.11-18.38 11.33-53.1l-22.3 31.9 10.97 21.2m-265.52 86.44s-49.85 23.69-44.36 96.49l95.57-83.61-51.21-12.88",
    style: {
      fill: "#473543",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4357.46 4445.04c-16.13-8.45-37.66-10-58.96-4.15-19.52 5.27-36.7 17.59-47.21 33.62a4.837 4.837 0 0 1-2.68 1.98c-1.27.32-2.63.12-3.81-.61a4.675 4.675 0 0 1-1.34-6.47c11.75-17.96 30.93-31.66 52.56-37.54 23.57-6.44 47.55-4.65 65.78 4.92 2.26 1.19 3.18 4.01 1.97 6.32-1.17 2.28-4.04 3.12-6.31 1.93",
    style: {
      fill: "#9d7155",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4446.03 4295.02v63.72l-50.58 13.56-63.75-7.66-66.17 7.66-50.55-13.56V4240.9c33.71-21.52 73.83-34.03 116.74-34.03 41.93 0 81.05 11.84 114.31 32.39v55.76",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4395.45 4372.3s-32.48 8.07-42.27 9.97c-1.56-3.21-4.98-11-22.61-11.84h-.14c-15.12-.19-21.19 9.42-20.12 11.84-9.8-1.9-44.78-9.97-44.78-9.97l-3.23-.84c22.54-23.98 68.19-21.42 68.19-21.42s45.64-2.56 68.18 21.42l-3.22.84",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4446.03 3992.98h-231.05v302.04h231.05v-302.04",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4445.9 4174.36h-230.61v25.29h230.61v-25.29m0-49.56h-230.61v25.25h230.61v-25.25m0-46.34h-230.61v25.24h230.61v-25.24",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4692.85 3621.79h49.4v394h-49.4v-394m-754.06 0h-49.38v394h49.38v-394",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4712.32 3937.43h-805.33v114.32h805.33v-114.32",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4742.25 3994.58h-852.84v81.94h852.84v-81.94",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4211.21 4326.98s-37.05 36.11-55.29-47.01c-18.24-83.11-.28-194.77 34.72-208.99 35-14.2 30.92 123.97 25.3 158.47-5.63 34.55-2.85 68.57-2.85 68.57l-1.88 28.96",
    style: {
      fill: "#ffebc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4236.97 3956.62c-32.91.33-59.88-26.35-60.06-59.61l-1.05-84.53h119.67l.76 83.33c.21 33.24-26.39 60.43-59.32 60.81m247.07-59.61c-.17 33.26-27.15 59.94-60.06 59.61-32.93-.38-59.53-27.57-59.29-60.81l.74-83.33h119.67l-1.06 84.53",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4222.17 4360.67-6.88-110.93s-70.02-5.38-74.04 6.1c.49 26.76 18.48 68.93 26.82 81.02 15.17 21.93 54.1 23.81 54.1 23.81",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4262.25 4363.56s-108.44-208.15-76.35-288.87c12.69-31.92 63.77-22.42 76.35 61.26 12.57 83.7 35.62 220.37 35.62 220.37s-22.95 85.31-55.19 85.75c-29.61.43 14.47-54.72 19.57-78.51m189.94-36.58s37.05 36.11 55.29-47.01c18.24-83.11.29-194.77-34.71-208.99-35.02-14.2-30.92 123.97-25.31 158.47 5.63 34.55 2.85 68.57 2.85 68.57l1.88 28.96",
    style: {
      fill: "#ffebc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4441.25 4360.67 6.85-110.93s70.03-5.38 74.05 6.1c-.49 26.76-18.48 68.93-26.82 81.02-15.15 21.93-54.08 23.81-54.08 23.81",
    style: {
      fill: "#467a9b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4401.17 4363.56s108.44-208.15 76.35-288.87c-12.7-31.92-63.79-22.42-76.35 61.26-12.58 83.7-35.64 220.37-35.64 220.37s22.95 85.31 55.19 85.75c29.61.43-14.45-54.72-19.55-78.51",
    style: {
      fill: "#ffebc6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06187 0 0 -.06187 -214.526 298.085)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent5);
export default __webpack_public_path__ + "static/media/student5.89e4eec02524822c803e6a2fdb620e4e.svg";
export { ForwardRef as ReactComponent };